import styled, { css } from 'styled-components';

export const TableBodyRoot = styled.tbody`
    display: table-row-group;
		${(props) => props.disabled && css`
			position: relative;
			&:after {
				content: '';
				top: 0;
				left: 0;
				position: absolute;
				height: 100%;
				width: 100%;
				z-index: 1;
				background: #fff;
				opacity: 0.6;
				cursor: not-allowed;
			}
		`}
`;
